/**
 * Final IOWEU XML Parser
 * Merges Questions, Coaching, and Score-specific Feedback
 */
export const parseRelationshipQuiz = (questionsXml, detailXml, scoreDetailXml) => {
  const parser = new DOMParser();
  
  // 1. Parse Coaching Detail Map (Help text for questions)
  const helpMap = {};
  if (detailXml) {
    const dDoc = parser.parseFromString(detailXml, "text/xml");
    dDoc.querySelectorAll("question").forEach(q => {
      const id = q.getAttribute("id");
      const parts = [];
      ['T', 'A', 'P', 'S'].forEach(tag => {
        const content = q.querySelector(tag)?.textContent?.trim();
        if (content) parts.push(`**${tag}:** ${content}`);
      });
      helpMap[id] = parts.join('\n\n');
    });
  }

  // 2. Parse Score Feedback Map (Results feedback)
  const feedbackMap = {};
  if (scoreDetailXml) {
    const sDoc = parser.parseFromString(scoreDetailXml, "text/xml");
    sDoc.querySelectorAll("type").forEach(typeNode => {
      const typeId = typeNode.getAttribute("id");
      feedbackMap[typeId] = [];

      typeNode.querySelectorAll("detail").forEach(detailNode => {
        const scoreRange = detailNode.getAttribute("score");
        const meetings = {};
        
        detailNode.querySelectorAll("meeting").forEach(meetNode => {
          const mid = meetNode.getAttribute("id");
          meetings[mid] = Array.from(meetNode.querySelectorAll("item")).map(i => i.textContent.trim());
        });

        feedbackMap[typeId].push({ scoreRange, meetings });
      });
    });
  }

  // 3. Parse Questions
  const qDoc = parser.parseFromString(questionsXml, "text/xml");
  const questions = Array.from(qDoc.querySelectorAll("question")).map(qNode => {
    const id = qNode.getAttribute("id");
    const type = qNode.getAttribute("type");
    const config = qNode.querySelector("config");
    const leftNode = config?.querySelector("left");
    const rightNode = config?.querySelector("right");

    const originalConfig = {
      left: { label: leftNode?.getAttribute("value"), weightings: (leftNode?.getAttribute("weightings") || "").split(",") },
      right: { label: rightNode?.getAttribute("value"), weightings: (rightNode?.getAttribute("weightings") || "").split(",") }
    };

    let options = [];
    if (type === "range") {
      options = [
        { value: "L3", label: `${originalConfig.left.label} (Strong)`, weight: 3, side: 'left' },
        { value: "L2", label: `${originalConfig.left.label} (Moderate)`, weight: 2, side: 'left' },
        { value: "1", label: `Balanced / Neutral`, weight: 1, side: 'center' },
        { value: "R2", label: `${originalConfig.right.label} (Moderate)`, weight: 2, side: 'right' },
        { value: "R3", label: `${originalConfig.right.label} (Strong)`, weight: 3, side: 'right' }
      ];
    } else {
      options = [
        { value: "L", label: originalConfig.left.label, weight: 1, side: 'left' },
        { value: "R", label: originalConfig.right.label, weight: 1, side: 'right' }
      ];
    }

    return {
      id,
      questionText: qNode.querySelector("value")?.textContent || "",
      options,
      helpText: [qNode.querySelector("help")?.textContent, helpMap[id]].filter(Boolean).join("\n\n---\n\n"),
      originalConfig
    };
  });

  return {
    id: qDoc.querySelector("relationship-scoring-questions")?.getAttribute("id") || "ioweu",
    title: "IOWEU Relationship Assessment",
    questions,
    feedbackMap
  };
};